import { Link } from 'react-router-dom';
import footerLogo from './Asstes/sanglizp.png';

const Footer = () => {
  return (
    <footer style={{ background: 'linear-gradient(180deg, #1a1048 0%, #120c35 100%)', borderTop: '4px solid #3b82f6', fontFamily: 'Inter, sans-serif' }}>

      {/* Main Content */}
      <div className="max-w-screen-xl mx-auto px-4 sm:px-6 pt-10 pb-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-10">

          {/* Column 1 - Logo & About */}
          <div className="sm:col-span-2 md:col-span-1">
            <div style={{ background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 14, display: 'inline-block', padding: '10px 16px', marginBottom: 18 }}>
              <img src={footerLogo} alt="Zilla Parishad Sangli" style={{ height: 58, width: 'auto', display: 'block' }} />
            </div>
            <p className="text-sm leading-relaxed mb-5" style={{ color: 'rgba(255,255,255,0.55)' }}>
              महाराष्ट्रामध्ये दि. ०१ मे, १९६० रोजी तात्कालीन पंतप्रधान मा. पंडित जवाहरलाल नेहरू यांच्या अध्यक्षतेखाली जिल्हा परिषदांची स्थापना करण्यात आली.
            </p>
          </div>

          {/* Column 2 - Quick Links */}
          <div>
            <div className="flex items-center gap-2 mb-5">
              <div style={{ width: 3, height: 18, background: '#3b82f6', borderRadius: 2 }} />
              <h4 className="text-white text-sm font-bold tracking-wide m-0">जलद दुवे</h4>
            </div>
            <ul className="list-none p-0 m-0 space-y-2">
              {[
                { label: 'मुख्यपृष्ठ', path: '/' },
                { label: 'अभियंता नोंदणी अर्ज', path: '/engineer-registration' },
                { label: 'संस्था नोंदणी अर्ज', path: '/society-registration' },
                { label: 'अभियंता लॉटरी अर्ज', path: '/engineer-lottery-registration' },
                { label: 'संस्था लॉटरी अर्ज', path: '/society-lottery-registration' },
              ].map(({ label, path }) => (
                <li key={path}>
                  <Link
                    to={path}
                    className="flex items-center gap-2 text-sm no-underline transition-colors duration-200"
                    style={{ color: 'rgba(255,255,255,0.5)' }}
                    onMouseEnter={e => (e.currentTarget.style.color = '#93c5fd')}
                    onMouseLeave={e => (e.currentTarget.style.color = 'rgba(255,255,255,0.5)')}
                  >
                    <svg width={10} height={10} fill="none" stroke="#3b82f6" strokeWidth={2.5} viewBox="0 0 24 24">
                      <path d="M9 18l6-6-6-6" />
                    </svg>
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 3 - Contact */}
          <div>
            <div className="flex items-center gap-2 mb-5">
              <div style={{ width: 3, height: 18, background: '#3b82f6', borderRadius: 2 }} />
              <h4 className="text-white text-sm font-bold tracking-wide m-0">जिल्हा परिषद सांगली</h4>
            </div>

            {/* Address */}
            <div className="flex gap-2 mb-4 items-start">
              <span className="text-base mt-0.5">📍</span>
              <p className="text-sm leading-relaxed m-0" style={{ color: 'rgba(255,255,255,0.5)' }}>
                Sangli Z P, Khanbhag,<br />Sangli, Maharashtra 416416
              </p>
            </div>

            {/* Phone */}
            <div className="flex gap-2 mb-5 items-center">
              <span className="text-base">📞</span>
              <p className="text-sm m-0" style={{ color: 'rgba(255,255,255,0.5)' }}>0233 237 2725</p>
            </div>

            {/* Helpline Box */}
            <div style={{ background: 'rgba(59,130,246,0.12)', border: '1px solid rgba(59,130,246,0.25)', borderRadius: 12, padding: '14px 16px' }}>
              <p className="m-0 mb-1" style={{ color: 'rgba(255,255,255,0.4)', fontSize: 10, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.12em' }}>
                कामवाटप सपोर्ट नंबर
              </p>
              <p className="text-white font-black m-0 text-xl" style={{ letterSpacing: '0.04em' }}>
                9318151515
              </p>
            </div>
          </div>

        </div>
      </div>

      {/* Separator */}
      <div className="max-w-screen-xl mx-auto px-4 sm:px-6">
        <div style={{ height: 1, background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.1), transparent)' }} />
      </div>

      {/* Bottom Bar */}
      <div className="max-w-screen-xl mx-auto px-4 sm:px-6 py-4 flex flex-col sm:flex-row justify-between items-center gap-2 text-center sm:text-left">
        <p className="m-0 text-xs" style={{ color: 'rgba(255,255,255,0.3)' }}>
          &copy; {new Date().getFullYear()} जिल्हा परिषद, सांगली. All rights reserved.
        </p>
        <p className="m-0" style={{ color: 'rgba(255,255,255,0.2)', fontSize: 11 }}>
          Powered by <span style={{ color: '#3b82f6', fontWeight: 600 }}>VishwaDIgiTech</span>
        </p>
      </div>

    </footer>
  );
};

export default Footer;
